const front_sections = [
    {
      image: 'images/img1.jpg',
      title: 'Whoever',
      description: 'No matter who you re looking to hire—whether full-time employees or contractors—we make the process effortless.',
      buttons: [
        { text: 'Employees', url: '/companies-hiring-internationally' },
        { text: 'Contractors', url: '/contractors' }
      ]
    },
    {
      image: 'images/img2.jpg',
      title: 'Wherever',
      description: 'Our expertise across 40+ countries allows us to meet your hiring needs and support your business growth, no matter where you expand!',
      buttons: [
        { text: 'Countries We Support', url: '/countries' },
        { text: 'Get Expansion Advice', url: '/meet-the-experts' }
      ]
    },
    {
      image: 'images/img3.jpg',
      title: 'Whatever you do',
      description: 'No matter your industry, we customize global employment solutions to fit your unique needs. Choose your business type to get started!',
      buttons: [
        { text: 'Recruitment Agencies', url: '/staffing-and-recruitment-firms' },
        { text: 'HR & Direct Employers', url: '/companies-hiring-internationally' }
      ]
    }
  ];
  export { front_sections };